<template>
  <div class="forum-introduce-by-day" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <ModuleNav :normal="nav.normal" :hover="nav.hover" :isInModule="isInModule"/>
    <div class="content">
      <div class="day">
        <div class="left">
          <img :src="daysInfo[0].image" :style="{transform:`translate3d(${firstImagePosition}px,0,0)`}">
          <p class="brief">
            {{daysInfo[0].brief}}
          </p>
          <p class="detail" v-html="daysInfo[0].detail"/>
        </div>
        <div class="line"></div>
      </div>
      <div class="day">
        <div class="left">
          <p class="detail" v-html="daysInfo[1].detail"/>
          <img :src="daysInfo[1].image" :style="{transform:`translate3d(${secondImagePosition}px,0,0)`}">
          <p class="brief">
            {{daysInfo[1].brief}}
          </p>
        </div>
        <div class="line"></div>
      </div>
      <div class="day">
        <div class="left">
          <img :src="daysInfo[2].image" :style="{transform:`translate3d(${thirdImagePosition}px,0,0)`}">
          <p class="brief">
            {{daysInfo[2].brief}}
          </p>
          <p class="detail" v-html="daysInfo[2].detail"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ModuleNav from './ModuleNav';
  import { mapState } from 'vuex';

  export default {
    name: 'ForumIntroduceByDay',
    components: { ModuleNav },
    computed: {
      ...mapState({
        nav: state => state.forumIntroduceByDay.nav,
        daysInfo: state => state.forumIntroduceByDay.daysInfo,
      }),
    },
    data() {
      return {
        isInModule: false,
        scrollHeight: 0,
        firstImagePosition: 0,
        secondImagePosition: 0,
        thirdImagePosition: 0,
      };
    },
    created() {
      window.addEventListener('scroll', this.handleScroll, false);
    },
    methods: {
      mouseEnter() {
        this.isInModule = true;
      },
      mouseLeave() {
        this.isInModule = false;
      },
      handleScroll() {
        const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const scrollInstance = scrollHeight - this.scrollHeight;
        this.scrollHeight = scrollHeight;
        const { left, width } = document.querySelector('.forum-introduce-by-day')
          .getBoundingClientRect();
        if (left <= document.body.offsetWidth && left >= -width) {
          this.firstImagePosition -= scrollInstance / 30;
          this.secondImagePosition -= scrollInstance / 40;
          this.thirdImagePosition -= scrollInstance / 50;
        }
      },
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  };
</script>

<style scoped lang="less">
  .forum-introduce-by-day {
    display: flex;
    height: 100vh;
  }

  .content {
    display: flex;
    height: 86vh;
    margin-top: 7vh;

    > div {
      height: 100%;
      box-sizing: border-box;

      img {
        transition: transform .5s ease-out;
      }
    }
  }

  .line {
    width: 1px;
    height: 86vh;
    background: #000;
  }

  .day {
    display: flex;
    align-items: center;

    .left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      width: 60vh;
      height: 84vh;
      padding: 0 5vh;

      img {
        width: 90%;
        align-self: flex-end;
        transition: transform .5s ease-out;
      }

      .brief {
        width: 40vh;
        line-height: 1.5;
        text-align: justify;
        font-size: 2.6vh;
        font-weight: 100;
      }

      .detail {
        width: 35vh;
        align-self: flex-start;
        line-height: 1.5;
        text-align: justify;
        font-size: 1.7vh;
        font-weight: bold;
      }
    }

    .line {
      width: 1px;
      height: 86vh;
      background: #000;
    }

  }
</style>
